module.exports = __webpack_public_path__ + "img/logo_3@2x.8ee1eb13.png";